import { defineComponent } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
import { numberFormat } from '@/utils/helpers';
import { storeToRefs } from 'pinia';
import BankDetailsComponent from './BankDetailsComponent.vue';
export default defineComponent({
    name: 'BankDeposit',
    components: {
        BankDetailsComponent,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { selectedCurrency, selectedFiatAmountWithoutFees } = storeToRefs(transactionsStore);
        return {
            selectedCurrency,
            numberFormat,
            selectedFiatAmountWithoutFees,
        };
    },
});
